<div class="content">
  <ng-template #selectVessel>
    <h1>Please select a vessel</h1>
  </ng-template>

  <div *ngIf="getSelectedVesselId(); else selectVessel">
    <div class="separator">
      <h1>{{ getVesselName() }}</h1>
    </div>

    <div class="flex flex-wrap mb-4 mt-2 gap-5">
      <div>IMO {{ selectedVessel?.imo !== null ? selectedVessel?.imo : "NV" }}</div>
      <div>DWT {{ selectedVessel?.dwt !== null ? (selectedVessel?.dwt | number: "1.0-0") : "NV" }}</div>
      <div>GT {{ selectedVessel?.gt !== null ? (selectedVessel?.gt | number: "1.0-0") : "NV" }}</div>
    </div>
    <div class="flex flex-column gap-6">
      <div class="flex gap-8 change-direction">
        <div class="flex flex-column gap-0 flex-wrap flex-auto" [ngClass]="{ spinner: ciiReport === undefined }">
          <div class="separator">
            <h2 class="pl-2">Summary Current Year</h2>
          </div>
          <div class="flex gap-5 summary-container">
            <div class="left-summary">
              <div class="property side-by-side separator">
                <div>Total Time [d]</div>
                <div class="value">
                  {{ valueOrNV(ciiReport?.timeTotal_d, "1.0-0") }}
                </div>
              </div>
              <div class="property side-by-side separator">
                <div>Steaming Time [d]</div>
                <div class="value">
                  {{ valueOrNV(ciiReport?.steamingTimeTotal_d, "1.1-1") }}
                </div>
              </div>
              <div class="property side-by-side separator">
                <div>Average Speed [kn]</div>
                <div class="value">
                  {{ valueOrNV(ciiReport?.speedAverage_kn, "1.1-1") }}
                </div>
              </div>
              <div class="property side-by-side separator">
                <div>Fuel Consumption [t]</div>
                <div class="value">
                  {{ valueOrNV(ciiReport?.fuelConsumptionTotal_t, "1.0-0") }}
                </div>
              </div>
              <div class="property side-by-side separator">
                <div>Total Distance Sailed [nm]</div>
                <div class="value">
                  {{ valueOrNV(ciiReport?.distanceTotal_nm, "1.0-0") }}
                </div>
              </div>
            </div>
            <div class="right-summary">
              <div class="property side-by-side separator">
                <div>CO<sub>2</sub> Emission Total [t]</div>
                <div class="value">
                  {{ valueOrNV(ciiReport?.co2Total_t, "1.0-0") }}
                </div>
              </div>
              <div class="property side-by-side separator">
                <div>CO<sub>2</sub> after Exclusions [t]</div>
                <div class="value">
                  {{ valueOrNV(ciiReport?.co2AfterExclusions_t, "1.0-0") }}
                </div>
              </div>
              <div class="property side-by-side separator">
                <div>CO<sub>2</sub> Propulsion [%]</div>
                <div class="value">
                  {{ valueOrNV(ciiReport?.co2Propulsion_percent, "1.0-0") }}
                </div>
              </div>
              <div class="property side-by-side separator">
                <div>CO<sub>2</sub> Unrelated to Prop. [%]</div>
                <div class="value">
                  {{ valueOrNV(ciiReport?.co2WithoutPropulsion_percent, "1.0-0") }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="flex flex-column flex-initial flex-shrink-0 cii-rating-container">
          <div class="separator">
            <h2 class="pl-2">Cii Rating Current Year</h2>
          </div>
          <app-cii-rating-gauge-diagramm
            class="flex justify-content-center"
            [ciiRangesCurrentYear]="ciiRangesCurrentYear"
            [ciiRating]="ciiRating"
            [aer_gtnm]="aer_gtnm"></app-cii-rating-gauge-diagramm>
        </div>
      </div>

      <div class="flex flex-column gap-0 flex-wrap flex-auto min-w-0">
        <div class="separator">
          <div class="history-title">
            <h2 class="pl-2">Cii Rating</h2>
            <div class="history-years">
              <button pButton *ngFor="let year of availableHistoryYears" (click)="onYearSelect(year)" [class.active]="year === selectedYear$.value">
                {{ year }}
              </button>
            </div>
          </div>
        </div>
        <div class="tracks-scroller">
          <app-cii-rating-tracks
            [ciiRanges]="ciiRanges"
            [selectedYear]="selectedYear$ | async"
            [ciiTracks]="ciiTracks"
            [availableHistoryYears]="availableHistoryYears"></app-cii-rating-tracks>
        </div>
      </div>
    </div>
  </div>
</div>
